export type Network = 'TIM' | 'Vodafone' | 'WindTre' | 'Iliad' | 'Fastweb';

const MNC: Record<number, Network> = { 1: 'TIM', 10: 'Vodafone', 88: 'WindTre', 99: 'WindTre', 50: 'Iliad', 8: 'Fastweb' };

export function networkFromMnc(mnc: number): Network | null {
  return MNC[mnc] ?? null;
}

/** Colors chosen to stay distinguishable on light and dark map tiles. */
export const NETWORKS: Record<Network, { color: string; brands: string[] }> = {
  TIM: { color: '#1f6fd1', brands: ['TIM', 'Kena'] },
  Vodafone: { color: '#d62f2f', brands: ['Vodafone', 'ho.'] },
  WindTre: { color: '#e67e00', brands: ['WindTre', 'very'] },
  Iliad: { color: '#8a3ffc', brands: ['Iliad'] },
  Fastweb: { color: '#c9a400', brands: ['Fastweb'] },
};

export const NETWORK_ORDER: Network[] = ['TIM', 'Vodafone', 'WindTre', 'Iliad', 'Fastweb'];
